// src/components/InvoiceViewerSelector.jsx
import React, { useContext } from "react";
import { UserContext } from "../context/UserContext";

import DefaultInvoiceViewer from "./invoiceTemplates/PDFviewer";
import ClinicInvoiceViewer from "./invoiceTemplates/ClinicInvoiceViewer";

const InvoiceViewerSelector = () => {
  const { user } = useContext(UserContext);

  console.log("User's selected invoice template:", user?.invoiceTemplate);

  if (!user) {
    return null;
  }

  const templateMap = {
    default: DefaultInvoiceViewer,
    clinic: ClinicInvoiceViewer,
  };

  const SelectedViewer =
    templateMap[user.invoiceTemplate] || DefaultInvoiceViewer;

  return <SelectedViewer />;
};

export default InvoiceViewerSelector;
